import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const vehicleDeliveryStatusEnum = createEnum({
    PENDING: ['pending', '待交付', 'default'],
    DELIVERED: ['delivered', '已交付', 'success'],
});
export const VEHICLE_DELIVERY_STATUSES = enumValues(vehicleDeliveryStatusEnum);
export const VEHICLE_DELIVERY_STATUS_LABEL_MAP = enumLabelMap(vehicleDeliveryStatusEnum);
export const vehicleCancellationStatusEnum = createEnum({
    PENDING: ['pending', '待注销', 'default'],
    PROCESSING: ['processing', '注销中', 'processing'],
    CANCELLED: ['cancelled', '已注销', 'success'],
});
export const VEHICLE_CANCELLATION_STATUSES = enumValues(vehicleCancellationStatusEnum);
export const VEHICLE_CANCELLATION_STATUS_LABEL_MAP = enumLabelMap(vehicleCancellationStatusEnum);
//# sourceMappingURL=vehicle-delivery.js.map